import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";


let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";
 
if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "sr_no",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "#",
    },
  },
  {
    label: "Party Name",
    field: "party_name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Party Name",
    },
  },
  {
    label: "Sale Quantity",
    field: "sale_qty",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Sale Quantity",
    },
  },
  {
    label: "Sale Amount",
    field: "sale_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Sale Amount",
    },
  },
  {
    label: "Purchase Quantity",
    field: "purchase_qty",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Purchase Quantity",
    },
  },
  {
    label: "Purchase Amount",
    field: "purchase_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Purchase Amount",
    },
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      total: 0,
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      dateLabel: "",
      itemArrayList: [],
      selectedItemId: "0",
      categoryArray: [],
      selectedCategoryId: "0",
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getItemList();
    this.getCategoryList();
    this.getSaleListData(this.state.activeTransactionKey);
  }

  getItemList() {
    const requestData = JSON.stringify({
      company_id: this.state.company_id,
    });
    PostData(global.userItemList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success && responseJson.response) {
          this.setState({ itemArrayList: responseJson.response });
        }
      })
      .catch((error) => console.error("Item List Error: ", error));
  }

  getCategoryList() {
    const requestData = JSON.stringify({
      businessId: this.state.businessId,
      company_id: this.state.company_id,
    });
    PostData(global.itemCategoryList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success && responseJson.response) {
          this.setState({ categoryArray: responseJson.response });
        }
      })
      .catch((error) => console.error("Category List Error: ", error));
  }

  handleItemFilter = (itemId) => {
    this.setState({
      selectedItemId: itemId
    }, () => this.getSaleListData(this.state.activeTransactionKey));
  };

  handleCategoryFilter = (categoryId) => {
    this.setState({
      selectedCategoryId: categoryId
    }, () => this.getSaleListData(this.state.activeTransactionKey));
  };

  getSaleListData(_type) {
    let _transArray = [];
    let _totalSaleQty = 0;
    let _totalSaleAmt = 0;
    let _totalPurchaseQty = 0;
    let _totalPurchaseAmt = 0;

    const requestData = JSON.stringify({
        business_id: this.state.businessId,
        company_id: this.state.company_id,
        type: _type,
        isDateFilter: true,
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        item_id: this.state.selectedItemId,
        category_id: this.state.selectedCategoryId,
    });

    PostData(global.userPartyItem, requestData, "POST")
        .then((result) => {
            let responseJson = result;

            if (responseJson.success === false) {
                this.setState({
                    transactionArrayFilter: _transArray,
                    itemArray: _transArray,
                    isLoaded: true,
                    totalSaleQty: _totalSaleQty,
                    totalSaleAmt: _totalSaleAmt,
                    totalPurchaseQty: _totalPurchaseQty,
                    totalPurchaseAmt: _totalPurchaseAmt,
                });
            } else {
                if (responseJson.response) {
                    _transArray = responseJson.response;

                    _transArray.map((itm) => {
                        _totalSaleQty += parseFloat(itm.total_sale_quantity || 0);
                        _totalSaleAmt += parseFloat(itm.total_sales || 0);
                        _totalPurchaseQty += parseFloat(itm.total_purchase_quantity || 0);
                        _totalPurchaseAmt += parseFloat(itm.total_purchases || 0);
                    });
                }

                this.setState({
                    transactionArrayFilter: _transArray,
                    itemArray: _transArray,
                    isLoaded: true,
                    totalSaleQty: _totalSaleQty,
                    totalSaleAmt: _totalSaleAmt,
                    totalPurchaseQty: _totalPurchaseQty,
                    totalPurchaseAmt: _totalPurchaseAmt,
                });
            }
        })
        .catch((error) => this.setState({ error, isLoaded: false }));
}

loadTranscListing() {
    let dataList = [];
    let rows = [];

    if (this.state.isLoaded) {
        let _transDetails = this.state.transactionArrayFilter;
        if (_transDetails.length > 0) {
            _transDetails.map((value, index) => {
                rows.push({
                    srNo: index + 1,
                    party_name: value.party_name,
                    total_sale_quantity: (value.total_sale_quantity || 0),
                    total_sale_amount: numberFormat(value.total_sales || 0),
                    total_purchase_quantity: (value.total_purchase_quantity || 0),
                    total_purchase_amount: numberFormat(value.total_purchases || 0),
                });
            });
        }
    }

    // Define table columns
    const columns = [
        { label: "Sr No", field: "srNo", sort: "asc" },
        { label: "Party Name", field: "party_name", sort: "asc" },
        { label: "Sale Quantity", field: "total_sale_quantity", sort: "asc" },
        { label: "Sale Amount", field: "total_sale_amount", sort: "asc" },
        { label: "Purchase Qty", field: "total_purchase_quantity", sort: "asc" },
        { label: "Purchase Amount", field: "total_purchase_amount", sort: "asc" },
    ];

    if (rows.length > 0) {
        dataList = {
            columns: columns,
            rows: rows,
        };
    }

    return dataList;
}



  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    }, () => this.getSaleListData(this.state.activeTransactionKey));
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Party Report by Items</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-4">
                          <span>Date Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-4">
                          <span>Item : </span>
                          <select
                            className="form-control"
                            value={this.state.selectedItemId}
                            onChange={(e) => this.handleItemFilter(e.target.value)}
                          >
                            <option value="0">All Items</option>
                            {this.state.itemArrayList.map((item) => (
                              <option key={item.item_id} value={item.item_id}>
                                {item.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-4">
                          <span>Category : </span>
                          <select
                            className="form-control"
                            value={this.state.selectedCategoryId}
                            onChange={(e) => this.handleCategoryFilter(e.target.value)}
                          >
                            <option value="0">All Categories</option>
                            {this.state.categoryArray.map((category) => (
                              <option key={category.id} value={category.id}>
                                {category.categoryName}
                              </option>
                            ))}
                          </select>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                        <i className="fa fa-plus-circle"></i> Add Sale
                    </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100 , 500]}
                      entries={25}
                      pagesAmount={4}
                      span
                      //pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
